import { render, staticRenderFns } from "./CommunicationTypeMail.vue?vue&type=template&id=6c5699a8"
import script from "./CommunicationTypeMail.vue?vue&type=script&lang=ts"
export * from "./CommunicationTypeMail.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationTypeMail.vue?vue&type=style&index=0&id=6c5699a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports